import { render, staticRenderFns } from "./OurTechApproach.vue?vue&type=template&id=d53d49ca&"
import script from "./OurTechApproach.vue?vue&type=script&lang=js&"
export * from "./OurTechApproach.vue?vue&type=script&lang=js&"
import style0 from "./OurTechApproach.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports